import { useEffect, useState } from "react";

// API
import { GetSingleArticle } from "../../../Api/Article";

// Models
import ArticleDTO from "../../../Models/DTOs/ArticleDTO";

function useFetchSingleArticle(id: number) {
    const [article, setArticle] = useState<ArticleDTO | null>(null);
    const [loading, setLoading] = useState<boolean>(true);
    const [error, setError] = useState<string | null>(null);

    useEffect(() => {
        setArticle(null);
        setError(null);
        if (!Number.isSafeInteger(id) || id <= 0) {
            setError("This article is currently unavailable.");
            setLoading(false);
            return;
        }

        const controller = new AbortController();

        const fetchArticle = async () => {
            setLoading(true);
            try {
                const response = await GetSingleArticle(id, controller);
                if (!controller.signal.aborted && response) {
                    setArticle(response);
                }
            } catch (err: any) {
                if (!controller.signal.aborted) {
                    console.error("Failed to fetch article:", err);
                    setError(err?.response?.status === 404
                        ? "This article is currently unavailable."
                        : "Unable to load this article. Please try again.");
                }
            } finally {
                if (!controller.signal.aborted) {
                    setLoading(false);
                }
            }
        };

        fetchArticle();

        return () => {
            controller.abort();
        };
    }, [id]);

    return { article, loading, error };
}

export default useFetchSingleArticle;
